module.exports = __webpack_public_path__ + "static/media/blessed_boots.12196873.png";